import { Navigate, Route, Routes } from "react-router-dom";
import { RequireAdmin, RequireAuth } from "./auth/RequireAuth.jsx";
import { Layout } from "./components/Layout.jsx";
import { LoginPage } from "./pages/LoginPage.jsx";
import { DashboardPage } from "./pages/DashboardPage.jsx";
import { PlaygroundDrawer } from "./pages/PlaygroundDrawer.jsx";
import { AccountabilityPage } from "./pages/AccountabilityPage.jsx";
import { CoreGroupPage } from "./pages/CoreGroupPage.jsx";
import { AccessPage } from "./pages/AccessPage.jsx";
import { DataPage } from "./pages/DataPage.jsx";
import { NotePage } from "./pages/NotePage.jsx";
import { ManualPage } from "./pages/ManualPage.jsx";
import { AccountPage } from "./pages/AccountPage.jsx";
import { DeniedPage } from "./pages/DeniedPage.jsx";
import { NotFoundPage } from "./pages/NotFoundPage.jsx";

/* Every view has an address.
 *
 * /login is the only route outside the gate. Everything else sits under
 * RequireAuth, and the two administrator pages under RequireAdmin as well —
 * the client's guards are what shape the UI, while the API refuses the same
 * calls on its own authority, so a hand-typed URL gains nothing.
 *
 * A playground is a nested route so the drawer opens over the board it came
 * from and /playground/p03 can be sent to someone in a message. */
export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      <Route element={<RequireAuth />}>
        <Route element={<Layout />}>
          <Route path="/" element={<DashboardPage />}>
            <Route path="playground/:id" element={<PlaygroundDrawer />} />
          </Route>
          <Route path="/accountability" element={<AccountabilityPage />} />
          <Route path="/core-group" element={<CoreGroupPage />} />
          <Route path="/note" element={<NotePage />} />
          <Route path="/manual" element={<ManualPage />} />
          <Route path="/account" element={<AccountPage />} />
          <Route path="/denied" element={<DeniedPage />} />

          <Route element={<RequireAdmin />}>
            <Route path="/access" element={<AccessPage />} />
            <Route path="/data" element={<DataPage />} />
          </Route>

          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Route>

      {/* An unauthenticated visitor to any other address is sent to the door,
          which then puts them back where they were going. */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
